import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "on-desktop ml-0-5"
}
const _hoisted_2 = {
  key: 0,
  class: "v-select-item sub"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "v-select-item sub"
}
const _hoisted_5 = ["onClick"]

import { computed, reactive, ref, watch } from 'vue';
import { useBlockListsStore } from '@/stores/blocks';
import { useCommentsStore } from '@/stores/comments';
import { useConfirmModal } from '@/stores/confirm-modal';
import { useDialogStore } from '@/stores/dialogs';
import CreateBlockListDialog from './dialogs/CreateBlockListDialog.vue';
import AddIcon from './icons/other/AddIcon.vue';
import SearchIcon from './icons/other/SearchIcon.vue';
import VAuthInput from './VAuthInput.vue';
import VCollapse from './VCollapse.vue';
import VSelect from './VSelect.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VBlockListSelect',
  props: {
    selected: null,
    small: { type: Boolean },
    ignoreItems: null,
    word: null,
    wordItem: null
  },
  setup(__props: any) {

const props = __props as { selected: any[], small?: boolean, ignoreItems?: any[], word?: string, wordItem?: any }

const blockListStore = useBlockListsStore()
const commentsStore = useCommentsStore()
const dialogStore = useDialogStore()


const searchValue = ref("")
const searching = computed(() => !!searchValue.value)
const selectRef = ref<any>()

const collapseRef = reactive<any>([ null, null ])
watch(searchValue, () => {
  for (let item of collapseRef) {
    if (!item) continue
    item.open()
  }
})

const onAddClick = () => {
  dialogStore.open(CreateBlockListDialog, { items: props.selected || [], word: props.word })
  selectRef.value.close()
}

const confirmModal = useConfirmModal()
const onItemClick = (e: MouseEvent, item: any) => {
  e.stopPropagation()
  e.preventDefault()
  if (props.word) {
    if (props.wordItem) {
      props.wordItem.block_lists.push(item)
    }
    if (!item.keys.includes(props.word)) {
      item.keys.push(props.word)
      blockListStore.editBlockList(item.id, item)
        .catch(() => {
          if (props.wordItem) {
            props.wordItem.block_lists.pop()
          }
          item.keys.pop()
        })
    }
    selectRef.value.close()
  } else {
    const itemsTitle = props.selected.length === 1? ("the "+props.selected[0].name): ("this "+props.selected.length + " items")
    confirmModal.open(e, `Are you sure you want to add ${item.name} to ${itemsTitle}?`, async () => {
      await commentsStore.connectBlockList(props.selected.map(item => item.id), item)
      selectRef.value.close()
    })
  }
}

const onTemplateClick = (e: MouseEvent, item: any) => {
  dialogStore.open(CreateBlockListDialog, { items: props.selected || [], template: item, word: props.word })
  selectRef.value.close()
}

const ignoreIds = computed(() => {
  const set = new Set<number>()
  for (let item of blockListStore.blockLists) {
    for (let sel of props.selected) {
      const comment = commentsStore.comments.find(item => item.id === sel.id)
      if (comment?.blocks.find(_item => _item.id === item.id)) {
        set.add(item.id)
        continue
      }
    }
  }
  if (props.ignoreItems) {
    for (let item of props.ignoreItems) {
      set.add(item.id)
    }
  }
  return set
})

const existing = computed(() => {
  const arr = blockListStore.blockLists.filter(item => !ignoreIds.value.has(item.id) && item.existing === true)
  if (!searching.value) return arr
  const val = searchValue.value.toLowerCase()
  return arr.filter(item => item.name.toLowerCase().includes(val))
})
const templates = computed(() => {
  const arr = blockListStore.blockLists.filter(item => !ignoreIds.value.has(item.id) && item.existing === false)
  if (!searching.value) return arr
  const val = searchValue.value.toLowerCase()
  return arr.filter(item => item.name.toLowerCase().includes(val))
})

const hasExistingItems = computed(() => !!blockListStore.blockLists.find(item => !ignoreIds.value.has(item.id) && item.existing === true))
const hasTemplateItems = computed(() => !!blockListStore.blockLists.find(item => !ignoreIds.value.has(item.id) && item.existing === false))

const defaultOpened = computed(() => existing.value.length + templates.value.length < 10)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VSelect, {
    ref_key: "selectRef",
    ref: selectRef,
    small: props.small,
    "menu-class": "template-select-menu",
    "mobile-close": ""
  }, {
    default: _withCtx(() => [
      _createTextVNode(" Add "),
      (!props.small)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, "Blocklist"))
        : _createCommentVNode("", true)
    ]),
    top: _withCtx(() => [
      (_unref(hasExistingItems) || _unref(hasTemplateItems))
        ? (_openBlock(), _createBlock(VAuthInput, {
            key: 0,
            modelValue: searchValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event)),
            icon: SearchIcon,
            placeholder: "Search",
            class: "light search template-select-input",
            autofocus: "",
            clearable: ""
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (!_unref(searching))
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "template-select-add-button",
            style: {"minWidth":"210px"},
            onClick: onAddClick
          }, [
            _createVNode(AddIcon),
            _createTextVNode(" Create new ")
          ]))
        : _createCommentVNode("", true),
      (_unref(hasExistingItems))
        ? (_openBlock(), _createBlock(VCollapse, {
            key: 2,
            ref: r => collapseRef[0] = r,
            opened: _unref(defaultOpened),
            title: "EXISTING"
          }, {
            default: _withCtx(() => [
              (_unref(existing).length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(searching)? "Nothing found": "No blocklists yet"), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(existing), (item) => {
                return (_openBlock(), _createElementBlock("button", {
                  class: "v-select-menu__button",
                  onClick: ($event: any) => (onItemClick($event, item))
                }, _toDisplayString(item.name), 9, _hoisted_3))
              }), 256))
            ]),
            _: 1
          }, 8, ["opened"]))
        : _createCommentVNode("", true),
      (_unref(hasTemplateItems))
        ? (_openBlock(), _createBlock(VCollapse, {
            key: 3,
            ref: r => collapseRef[1] = r,
            opened: _unref(defaultOpened),
            title: "TEMPLATES"
          }, {
            default: _withCtx(() => [
              (_unref(templates).length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(searching)? "Nothing found": "No templates yet"), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(templates), (item) => {
                return (_openBlock(), _createElementBlock("button", {
                  class: "v-select-menu__button",
                  onClick: ($event: any) => (onTemplateClick($event, item))
                }, _toDisplayString(item.name), 9, _hoisted_5))
              }), 256))
            ]),
            _: 1
          }, 8, ["opened"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["small"]))
}
}

})